import classNames from 'classnames/bind';
import { scrollXToCenter } from 'common/utils';
import { ReactNode, useEffect, useRef } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  children: ReactNode;
  isActive: boolean;
  isFocused?: boolean;
  isNpay?: boolean;
  nclkCode: string;
  onClick: () => void;
}

export default function Tag({
  children,
  isActive,
  isFocused = false,
  isNpay,
  nclkCode,
  onClick,
}: IProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isFocused && buttonRef.current) {
      scrollXToCenter(buttonRef.current);
    }
  }, [isFocused]);

  return (
    <button
      aria-checked={isActive}
      className={cx('Tag')}
      type="button"
      ref={buttonRef}
      data-event-nlog="click"
      data-event-area-code={nclkCode}
      onClick={onClick}
    >
      <span className={cx('name')}>
        {isNpay && <i className={cx('npay')} title="NPay" />}
        {children}
      </span>
    </button>
  );
}
